import React, {Component} from 'react';

class LineupPlayers extends Component {
    constructor(props) {
        super(props);
        if (typeof this.getTableHead !== 'function') {
            throw new Error('Method getTableHead is undefined.');
        }
        if (typeof this.getTableBody !== 'function') {
            throw new Error('Method getTableBody is undefined.');
        }
    }

    render() {
        return (
            <table className="table">
                <tbody>
                    {this.getTableHead()}
                    {this.getTableBody()}
                </tbody>
            </table>
        );
    }
}

export {LineupPlayers};
